module.exports = __webpack_public_path__ + "static/img/pic-homepage-cooperation4.59bf4e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic-homepage-cooperation4.png
// module id = 960
// module chunks = 0